import { render, staticRenderFns } from "./mappaturaPlu.vue?vue&type=template&id=448b2da1"
import script from "./mappaturaPlu.vue?vue&type=script&lang=js"
export * from "./mappaturaPlu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports